import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type QuestionPerformanceSubmissionFragment = { maxScore?: number | null, optionResponse?: Array<{ optionId: string, optionText: string }> | null, mtfResponse?: Array<{ leftElementId: string, rightElementIds: Array<string> }> | null, ftbResponse?: Array<{ blankId: string, text: string }> | null, imageHotspotResponse?: Array<{ id: string, text: string }> | null };


export type QuestionPerformanceSubmissionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type CorrectOptionsFragment = { optionId: string, optionText: string };


export type CorrectOptionsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type CorrectMtfPairingsFragment = { leftElementId: string, rightElementIds: Array<string> };


export type CorrectMtfPairingsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type CorrectFtbAnswersFragment = { id: string, text?: string | null };


export type CorrectFtbAnswersFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type CorrectImageHotspotAnswersFragment = { id: string, text?: string | null };


export type CorrectImageHotspotAnswersFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type QuestionPerformanceFragment = { id: string, entityId: string, contentId?: string | null, isSubmitted: boolean, parentAttemptId: string, score?: number | null, status: Types.PerformanceStatusEnum, evaluationStatus?: Types.PerformanceEvaluationStatusEnum | null, timeSpent: number, updatedAt: string, startedOn?: string | null, submission?: { maxScore?: number | null, optionResponse?: Array<{ optionId: string, optionText: string }> | null, mtfResponse?: Array<{ leftElementId: string, rightElementIds: Array<string> }> | null, ftbResponse?: Array<{ blankId: string, text: string }> | null, imageHotspotResponse?: Array<{ id: string, text: string }> | null } | null, correctOptions?: Array<{ optionId: string, optionText: string }>, correctMTFPairings?: Array<{ leftElementId: string, rightElementIds: Array<string> }>, correctFTBAnswers?: Array<{ id: string, text?: string | null }>, correctImageHotspotAnswers?: Array<{ id: string, text?: string | null }>, maxSubmissionDetails?: { score?: number | null, timeSpent: number, evaluationStatus?: Types.PerformanceEvaluationStatusEnum | null } | null, attempts: Array<{ parentAttemptId: string, score?: number | null, status: Types.PerformanceStatusEnum, evaluationStatus?: Types.PerformanceEvaluationStatusEnum | null, timeSpent: number, isSubmitted: boolean, updatedAt?: string | null, submission?: { maxScore?: number | null, optionResponse?: Array<{ optionId: string, optionText: string }> | null, mtfResponse?: Array<{ leftElementId: string, rightElementIds: Array<string> }> | null, ftbResponse?: Array<{ blankId: string, text: string }> | null, imageHotspotResponse?: Array<{ id: string, text: string }> | null } | null }> };


export type QuestionPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuestionPerformanceSubmissionFragmentDoc = /*#__PURE__*/ gql`
    fragment QuestionPerformanceSubmission on QuestionSubmissionType {
  maxScore
  optionResponse {
    optionId
    optionText
  }
  mtfResponse {
    leftElementId
    rightElementIds
  }
  ftbResponse {
    blankId
    text
  }
  imageHotspotResponse {
    id
    text
  }
}
    `;
export const CorrectOptionsFragmentDoc = /*#__PURE__*/ gql`
    fragment CorrectOptions on Option {
  optionId
  optionText
}
    `;
export const CorrectMtfPairingsFragmentDoc = /*#__PURE__*/ gql`
    fragment CorrectMTFPairings on MTFPairing {
  leftElementId
  rightElementIds
}
    `;
export const CorrectFtbAnswersFragmentDoc = /*#__PURE__*/ gql`
    fragment CorrectFTBAnswers on FTBComponent {
  id
  text
}
    `;
export const CorrectImageHotspotAnswersFragmentDoc = /*#__PURE__*/ gql`
    fragment CorrectImageHotspotAnswers on ImageHotspotComponent {
  id
  text
}
    `;
export const QuestionPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment QuestionPerformance on QuestionPerformanceType {
  id
  entityId
  contentId
  submission {
    ...QuestionPerformanceSubmission
  }
  isSubmitted
  correctOptions(filters: $previewFilter) @include(if: $fetchCorrectAnswers) {
    ...CorrectOptions
  }
  correctMTFPairings(filters: $previewFilter) @include(if: $fetchCorrectAnswers) {
    ...CorrectMTFPairings
  }
  correctFTBAnswers(filters: $previewFilter) @include(if: $fetchCorrectAnswers) {
    ...CorrectFTBAnswers
  }
  correctImageHotspotAnswers(filters: $previewFilter) @include(if: $fetchCorrectAnswers) {
    ...CorrectImageHotspotAnswers
  }
  maxSubmissionDetails {
    score
    timeSpent
    evaluationStatus
  }
  parentAttemptId
  score
  status
  evaluationStatus
  timeSpent
  updatedAt
  attempts {
    parentAttemptId
    score
    status
    evaluationStatus
    timeSpent
    isSubmitted
    updatedAt
    submission {
      ...QuestionPerformanceSubmission
    }
  }
  startedOn
}
    `;